var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-class page-center"},[_c('div',{staticClass:"page-staff-form"},[_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.title))]),_c('permission-form-box',{attrs:{"list-url":"/permissions","form-type":_vm.formType},on:{"add":_vm.onAdd,"edit":_vm.onEdit}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }